import { headingText } from '../utils/headingText';
export default function Questions({items, title='Questions nonprofit teams ask'}) {
  return <section className="search-questions"><h2>{headingText(title)}</h2>{items.map(([question,answer])=><details key={question}><summary>{question}<span aria-hidden="true">+</span></summary><p>{answer}</p></details>)}</section>;
}
